/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Verified = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Verified"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#5E1FF0"
        fillRule="evenodd"
        d="M19.989 14.73 22 12l-2.011-2.73.101-3.45-3.153-.965L15.09 2 12 3.168 8.91 2 7.063 4.855 3.91 5.82l.101 3.45L2 12l2.011 2.73-.101 3.45 3.153.965L8.91 22 12 20.832 15.09 22l1.847-2.855 3.153-.965z"
        className="Main"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M16.753 9.52a.93.93 0 0 0 .006-1.256.797.797 0 0 0-1.178-.007L10.25 13.86l-1.83-1.912a.797.797 0 0 0-1.18.007.93.93 0 0 0 .007 1.257l2.417 2.53a.797.797 0 0 0 1.172 0z"
        className="Details"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const VerifiedIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'verified-icon'}
      icon={Verified}
      {...props}
      size={size}
    />
  );
};
